import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { InfoIcon } from 'lucide-react'
import { useSelector } from 'react-redux'
import { useQuery } from 'react-query'
import { useStyles } from './styles'
import { getBaitPadDebounceWindowMin } from '../../api/device-api'

// The locale string carries two markers, kept identical to the mobile app so both
// clients share one translation: {{minutes}} and <bold>Maintenance mode</bold>.
const TOKEN_PATTERN = /(\{\{minutes\}\}|<bold>[\s\S]*?<\/bold>)/g
const BOLD_PATTERN = /^<bold>([\s\S]*)<\/bold>$/

export const BaitDebounceNotice = ({ onOpenMaintenanceMode }) => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const { data: minutes } = useQuery(
        ['bait-pad-debounce-window-min'],
        getBaitPadDebounceWindowMin,
        {
            refetchOnWindowFocus: false,
            refetchInterval: false,
            staleTime: Infinity,
            onError: () => {
                console.error('Error fetching bait pad debounce window')
            }
        }
    )

    if (!minutes) return null

    const renderPart = (part, index) => {
        if (part === '{{minutes}}') {
            return (
                <span
                    key={index}
                    className={classes.baitDebounceNoticeDuration}
                >
                    {minutes}
                </span>
            )
        }

        const boldMatch = part.match(BOLD_PATTERN)
        if (!boldMatch) {
            return <React.Fragment key={index}>{part}</React.Fragment>
        }

        const label = boldMatch[1]
        if (!onOpenMaintenanceMode) {
            return (
                <strong
                    key={index}
                    className={classes.baitDebounceNoticeStrong}
                >
                    {label}
                </strong>
            )
        }

        return (
            <button
                key={index}
                type="button"
                className={classes.baitDebounceNoticeAction}
                onClick={onOpenMaintenanceMode}
            >
                {label}
            </button>
        )
    }

    return (
        <Box className={classes.baitDebounceNotice}>
            <InfoIcon size={18} className={classes.baitDebounceNoticeIcon} />
            <Typography className={classes.baitDebounceNoticeText}>
                {locale.devices.baitStatusDebounceInfo
                    .split(TOKEN_PATTERN)
                    .map(renderPart)}
            </Typography>
        </Box>
    )
}
